import { createFileRoute } from '@tanstack/react-router';
import { SecurityPage } from '../../pages/SecurityPage';
import { staticPageHead } from '../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/security')({
  head: () =>
    staticPageHead({
      path: '/security',
      title: 'Security and trust - AnyAPI',
      description:
        'How AnyAPI handles your prepaid USD wallet, payments, and data. Payment security, data handling, and how to report a vulnerability.',
      crumb: 'Security',
      og: { title: 'Security and trust - AnyAPI' },
    }),
  component: SecurityPage,
});
